import { render, staticRenderFns } from "./FactorNewForm.vue?vue&type=template&id=80db89b6"
import script from "./FactorNewForm.vue?vue&type=script&lang=js"
export * from "./FactorNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports